import { render, staticRenderFns } from "./MainContentSupport.vue?vue&type=template&id=4af82984&scoped=true&lang=pug"
import script from "./MainContentSupport.vue?vue&type=script&lang=js"
export * from "./MainContentSupport.vue?vue&type=script&lang=js"
import style0 from "./MainContentSupport.vue?vue&type=style&index=0&id=4af82984&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af82984",
  null
  
)

export default component.exports